import gsap from "gsap";
import { ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export function playTransition() {
    gsap.to(window, { delay: 1, duration: 1, scrollTo: 0 });
    gsap.to(".transition-overlay", {
        ease: "Expo.easeInOut",
        duration: 1.0,
        height: "100%",
        top: "unset",
        bottom: "0",
    });
    gsap.to(".transition-overlay", {
        ease: "Expo.easeInOut",
        delay: 1.2,
        duration: 1,
        height: "0%",
        top: 0,
        bottom: "unset",
    });
    gsap.to(".trans-heading", {
        ease: "Expo.easeInOut",
        duration: 1.0,
        height: "100%",
        top: "unset",
        bottom: "0",
        
    });
    gsap.to(".trans-heading", {
        ease: "Expo.easeInOut",
        delay: 1.2,
        duration: 1,
        height: "0%",
        top: "-50%",
        bottom: "unset",
    });
}